module.exports = __webpack_public_path__ + "static/black-text-logo-6a3fda74acf17bed8b7e7f14409f4ef0.svg";